<template>
  <div id="loginBody">
    <div id="login">
      <b-img style="filter: invert(1);" :src="logo"/>
      <div class="m-2"/>
      <input
        type="text"
        name="username"
        class="form-control"
        v-model="user"
        placeholder="Jméno"
        v-on:keyup="validateLogin"
      >
      <div class="m-2"/>
      <input
        type="password"
        name="password"
        class="form-control"
        v-model="password"
        placeholder="Heslo"
        v-on:keyup="validateLogin"
      >
      <div class="m-3"/>
      <button type="button" class="btn btn-primary btn-block" v-on:click="login()">Přihlásit</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default Vue.extend({
  name: 'Login',
  data () {
    return {
      logo: require('../assets/logo_login.png'),
      user: '',
      password: ''
    }
  },
  mounted () {
    this.$store.dispatch('logout')
  },
  methods: {
    login () {
      const action = 'login'
      const user = this.user
      const password = this.password
      this.$store
        .dispatch('login', { action, user, password })
        .then(() => this.$router.push('/people'))
        .catch(err => {
          this.$bvToast.toast(`Nesprávné jméno nebo heslo`, {
            title: 'NEPŘIHLÁŠENO',
            variant: 'danger',
            autoHideDelay: 2000
          })
          console.log(err)
        })
    },
    validateLogin (e) {
      if (e.keyCode === 13) {
        this.login()
      }
    }
  }
})
</script>

<style scoped>
#loginBody {
  background-image: url("../assets/loginBackground.jpg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

#login {
  width: 500px;
  max-height: 280px;
  border: 0px solid #cccccc;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.5);
  margin: auto;
  margin-top: 200px;
  padding: 20px;
}
</style>
